import { bodyFilterField, queryFilterFiled } from "./list";
import { codeSchemaFields } from "../utils/code";
export const countApiTemplate = {
  name: 'count',
  desc: '查询总数',
  required: false,
  dbMethod: 'count',
  request: {
    query: {
      title: 'url参数',
      type: 'object',
      fields: [queryFilterFiled],
      useInDB: true
    },
    body: {
      type: 'object',
      title: 'post参数',
      fields: [bodyFilterField]
    }
  },
  response: {
    body: {
      title: '响应body',
      type: 'object',
      fields: [{
        id: 'data',
        type: 'object',
        title: '业务数据',
        fields: [{
          id: 'total',
          type: 'number',
          title: '数目'
        }]
      }, ...codeSchemaFields]
    }
  }
};
//# sourceMappingURL=count.js.map
